module.exports = __webpack_public_path__ + "static/media/Dr. Ijaz Gilani.cd271db8.jpg";